module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// C:/Source/hackathon/hackathon/web-app/node_modules/babel-runtime/core-js/symbol.js
// module id = ../../../node_modules/babel-runtime/core-js/symbol.js
// module chunks = 0